module.exports = __webpack_public_path__ + "static/media/trunk.3845f494.svg";